// @flow
import React from 'react';
import styled from 'styled-components';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { forEach } from 'lodash';

// list at https://github.com/FortAwesome/Font-Awesome/tree/master/js-packages/%40fortawesome/free-solid-svg-icons
import {
    faArchive,
    faArrowCircleDown,
    faArrowLeft,
    faArrowRight,
    faArrowUp,
    faArrowDown,
    faBan,
    faBell,
    faBook,
    faBriefcase,
    faBriefcaseMedical,
    faBuilding,
    faBullseye,
    faCalendar,
    faCar,
    faCaretDown,
    faCaretUp,
    faChartBar,
    faChartLine,
    faCheck,
    faCheckCircle,
    faCheckSquare,
    faChevronCircleLeft,
    faCode,
    faComment,
    faCompressAlt,
    faCircleNotch,
    faCircle,
    faCloudUploadAlt,
    faCog,
    faCreditCard,
    faDesktop,
    faDownload,
    faExclamationCircle,
    faExclamationTriangle,
    faExpandAlt,
    faExternalLinkSquareAlt,
    faEye,
    faEyeSlash,
    faFile,
    faFileCode,
    faFileContract,
    faFilePdf,
    faFlag,
    faFolder,
    faFolderOpen,
    faFastForward,
    faGift,
    faHeartbeat,
    faHistory,
    faHome,
    faIdCard,
    faInbox,
    faInfoCircle,
    faLayerGroup,
    faLeaf,
    faLifeRing,
    faLink,
    faList,
    faLock,
    faLockOpen,
    faMapMarker,
    faMinus,
    faMinusCircle,
    faMinusSquare,
    faMobileAlt,
    faMoneyBillAlt,
    faMoneyCheckAlt,
    faMotorcycle,
    faPaperclip,
    faPause,
    faPencilAlt,
    faPlane,
    faPlus,
    faPlusCircle,
    faQuestionCircle,
    faQuoteRight,
    faReceipt,
    faRoute,
    faSatelliteDish,
    faSearch,
    faServer,
    faShare,
    faShip,
    faSignature,
    faSignInAlt,
    faSpinner,
    faStickyNote,
    faSync,
    faTachometerAlt,
    faTag,
    faTasks,
    faTaxi,
    faTh,
    faTicketAlt,
    faTimes,
    faTimesCircle,
    faTools,
    faTooth,
    faTruck,
    faTruckMoving,
    faTruckPickup,
    faUndo,
    faUnlink,
    faUser,
    faUserCircle,
    faUserMd,
    faUserTag,
    faUserTimes,
    faUsers,
} from '@fortawesome/free-solid-svg-icons';

import {
    faAddressCard,
    faClock,
    faEnvelope,
    faFileAlt,
    faPaperPlane,
    faSquare,
} from '@fortawesome/free-regular-svg-icons';

// brands have a 'fab' prefix b/c FA overcomplicated it.
// list at https://github.com/FortAwesome/Font-Awesome/tree/master/js-packages/@fortawesome/free-brands-svg-icons
import {
    faApple,
    faGoogleWallet,
    faCcMastercard,
    faCcVisa,
} from '@fortawesome/free-brands-svg-icons';

library.add(
    faApple,
    faAddressCard,
    faArchive,
    faArrowCircleDown,
    faBan,
    faBell,
    faBook,
    faArrowLeft,
    faArrowRight,
    faArrowUp,
    faArrowDown,
    faBriefcase,
    faBriefcaseMedical,
    faBuilding,
    faBullseye,
    faCalendar,
    faCar,
    faCaretDown,
    faCaretUp,
    faChartLine,
    faChartBar,
    faCheck,
    faCheckCircle,
    faCheckSquare,
    faChevronCircleLeft,
    faClock,
    faLockOpen,
    faCircleNotch,
    faCircle,
    faCloudUploadAlt,
    faCog,
    faCreditCard,
    faCode,
    faComment,
    faCompressAlt,
    faDownload,
    faDesktop,
    faEnvelope,
    faExclamationCircle,
    faExclamationTriangle,
    faExpandAlt,
    faExternalLinkSquareAlt,
    faEye,
    faEyeSlash,
    faFile,
    faFileAlt,
    faFileCode,
    faFileContract,
    faFilePdf,
    faFlag,
    faFolder,
    faFolderOpen,
    faFastForward,
    faGoogleWallet,
    faGift,
    faHeartbeat,
    faHistory,
    faHome,
    faIdCard,
    faInbox,
    faInfoCircle,
    faLayerGroup,
    faLeaf,
    faLink,
    faLifeRing,
    faList,
    faLock,
    faMapMarker,
    faMinus,
    faMinusCircle,
    faMinusSquare,
    faMobileAlt,
    faMoneyBillAlt,
    faMoneyCheckAlt,
    faMotorcycle,
    faPaperPlane,
    faPaperclip,
    faPause,
    faPencilAlt,
    faPlane,
    faPlus,
    faPlusCircle,
    faQuestionCircle,
    faQuoteRight,
    faReceipt,
    faRoute,
    faSatelliteDish,
    faSearch,
    faServer,
    faShare,
    faShip,
    faSignInAlt,
    faSignature,
    faSpinner,
    faSquare,
    faStickyNote,
    faSync,
    faTachometerAlt,
    faTag,
    faTasks,
    faTaxi,
    faTh,
    faTicketAlt,
    faTimes,
    faTimesCircle,
    faTools,
    faTooth,
    faTruck,
    faTruckMoving,
    faTruckPickup,
    faUndo,
    faUnlink,
    faUser,
    faUserCircle,
    faUserMd,
    faUserTag,
    faUserTimes,
    faUsers,

    // brands:
    faCcMastercard,
    faCcVisa
);

const getIcons = () => {
    const defs = library.definitions;
    window.library = library;

    const data = {};

    // so what do we want? something like...
    //
    // {
    //   'paper-plane': {
    //      'prefixes': ['fab'],
    //   },
    //  }
    forEach(defs, (icons, prefix) => {
        forEach(icons, (icon, name) => {
            if (data[name]) {
                data[name].prefixes.push(prefix);
            } else {
                data[name] = { prefixes: [prefix] };
            }
        });
    });

    //  now in Icon we can do something like:
    //
    //  const { prefix, name } = props;
    //
    //  let icon = icons.get(name)
    //  let prefix = prefix ? prefix : icon.prefixes[0];
    //
    //  return <FontAwesomeIcon name={name} prefix={prefix} />;
    //
    //  so unless we have multiple prefixes for one name, it always just does the right thing

    return data;
};

export const icons = getIcons();

/**
 * Convenience wrapper for fontawesome icons.
 *
 * Any extra props will be passed to the containing span element.
 */

const StyledIcon = styled(FontAwesomeIcon)`
    &.sm {
        font-size: 1.4275rem;
    }
    &.md {
        font-size: 2rem;
    }
    &.lg {
        font-size: 4rem;
    }
    & + h5 {
        margin-left: 0.5rem;
    }
    a:hover &,
    &:hover {
        text-decoration: none !important;
    }
`;

type IconProps = {
    /** the fontawesome name */
    name: string,
    /** normal title attribute */
    title: string,
    /** prefix for icon. defaults to first registered variant */
    prefix: string,
};

export class Icon extends React.Component<IconProps> {
    static defaultProps = {
        prefix: '',
        title: '',
    };

    render() {
        let { name, prefix, title, ...domProps } = this.props;
        if (!name) {
            return '';
        }

        let icon = icons[name];

        if (!icon) {
            console.error(`Missing icon for ${name}`);
            name = 'exclamation-circle';
            icon = icons[name];
            title = 'Invalid icon';
        }

        if (!prefix) {
            prefix = icon.prefixes[0];
        } else if (icon.prefixes.indexOf(prefix) < 0) {
            name = 'exclamation-circle';
            icon = icons[name];
            prefix = icon.prefixes[0];
            title = 'Invalid prefix';
        }

        return <StyledIcon title={title} icon={[prefix, name]} {...domProps} />;
    }
}

export default Icon;
